import { render, staticRenderFns } from "./ConfigureSettingsNewTemp.vue?vue&type=template&id=7c7b355f&scoped=true"
import script from "./ConfigureSettingsNewTemp.vue?vue&type=script&lang=js"
export * from "./ConfigureSettingsNewTemp.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettingsNewTemp.vue?vue&type=style&index=0&id=7c7b355f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b355f",
  null
  
)

export default component.exports